import React from 'react'

type Props = {
  color?: 'white'
}

const YandexEnLogo: React.FC<Props> = ({color}) => {
  const fill = color === 'white' ? '#fff' : '#21201F'

  return (
    <svg fill="none" height="30" viewBox="0 0 116 30" width="116" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#a)">
        <path
          clipRule="evenodd"
          d="M14.012 28.922c7.734 0 14.003-6.27 14.003-14.003 0-7.734-6.27-14.003-14.003-14.003C6.28.916.01 7.186.01 14.92c0 7.733 6.27 14.003 14.002 14.003Zm.38-12.556c.819 1.792 1.091 2.415 1.091 4.568v2.854h-2.922v-4.812L7.048 6.985h3.049l4.295 9.38Zm3.604-9.381-3.574 8.124h2.97l3.585-8.124h-2.98Z"
          fill={fill}
          fillRule="evenodd"
        />
      </g>
      <path
        d="M34.406 6.152v17.767h3.912c4.908 0 8.436-3.17 8.436-8.973 0-6.545-3.503-8.794-8.18-8.794h-4.168Zm3.656 15.364h-.563V8.555h.819c3.118 0 5.291 1.56 5.291 6.34 0 4.397-2.198 6.62-5.547 6.62Zm20.641 1.534v-2.48c-.946.639-2.53 1.201-4.013 1.201-2.224 0-3.068-1.048-3.196-3.195h7.337v-1.61c0-4.474-1.968-6.162-5.01-6.162-3.707 0-5.471 2.838-5.471 6.724 0 4.474 2.198 6.646 6.084 6.646 1.943 0 3.375-.51 4.27-1.124Zm-4.934-9.843c1.509 0 1.969 1.253 1.969 2.864v.255h-4.244c.077-2.045.818-3.119 2.275-3.119Zm10.142-7.055H60.87v17.767h3.042V6.152Zm4.059 3.323c.997 0 1.79-.69 1.79-1.79 0-1.073-.793-1.789-1.79-1.789s-1.764.716-1.764 1.79c0 1.099.767 1.789 1.764 1.789ZM66.46 11.06v12.859h3.043V11.06H66.46Zm4.186 0 3.937 12.859h3.937l3.937-12.859h-2.94l-2.786 9.842-2.863-9.842h-3.222Zm22.558 11.99v-2.48c-.946.639-2.53 1.201-4.014 1.201-2.224 0-3.067-1.048-3.195-3.195h7.337v-1.61c0-4.474-1.969-6.162-5.01-6.162-3.708 0-5.471 2.838-5.471 6.724 0 4.474 2.198 6.646 6.084 6.646 1.943 0 3.374-.51 4.269-1.124Zm-4.934-9.843c1.508 0 1.969 1.253 1.969 2.864v.255h-4.244c.077-2.045.818-3.119 2.275-3.119Zm10.142 2.685c.844-1.56 2.096-2.352 3.963-2.25v-2.863c-1.739.102-3.17 1.15-3.886 2.837h-.077l-.077-2.556h-2.965v12.859h3.042v-8.027Zm7.631 11.99c2.838 0 3.886-2.02 4.755-4.653l4.014-12.169h-2.94l-2.837 9.663-2.838-9.663h-3.196l4.423 13.421c-.332.614-.818.997-1.662.997-.562 0-1.048-.179-1.38-.511v2.48s.46.434 1.661.434Z"
        fill={fill}
      />
      <defs>
        <clipPath id="a">
          <path d="M0 0h28.005v28.005H0z" fill="#fff" transform="translate(.01 .916)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default YandexEnLogo
